module.exports = __webpack_public_path__ + "media/icons/2@2x-923d8b85.png";